import isExperienceEditor from "@utils/is-experience-editor";

(function (window) {
    if ($('[data-slider="spotlight"]').length <= 0) {
        return;
    };

    var spotlightSlider = function () {
        var ui = {};

        function cacheUI() {
            ui.$body = $('body');
            ui.$spotLight = $('[data-slider="spotlight"]');
            ui.$spotLightContainer = $('.spotlight');
        }

        function initSpotLightSlider(e) {
            ui.$spotLight.each(function (index, element) {
                $(this).addClass('js-single-slide-slider' + index);
                var item_length = $('.js-single-slide-slider' + index + ' > div').length;
                if (item_length > 1 && !isExperienceEditor) {
                    $('.js-single-slide-slider' + index).slick({
                        autoplay: false,
                        infinite: false,
                        arrows: false,
                        dots: true,
                        slidesToShow: 1,
                        slidesToScroll: 1,
                        adaptiveHeight: true,
                        focusOnChange: true,
                        accessibility: true,
                        rows: 0 // Fix vor v1.8.0-1
                    });
                }
            });

            ui.$spotLightContainer.addClass('initialize');
        }

        function init() {
            cacheUI();
            initSpotLightSlider();
        }

        return {
            init: init
        };
    };

    var spotlightSlider = spotlightSlider();
    spotlightSlider.init();
})(window);